export const mapTeamData = (data) => {
  const team = data?.team;
  const mappedData = {
    uuid: team?.uuid,
    name: team?.name,
    isPartOfOrganization: !!team?.organization?.emailDomain,
    orgIsManualBilling: team?.organization?.isManualBilling,
    hasBillingSetup: !!team?.organization?.stripeCustomerId,
    emailDomain: team?.organization?.emailDomain,
    orgUuid: team?.organization?.uuid,
    location: team?.location,
    users: team?.userTeams?.map((userTeam) => ({
      uuid: userTeam?.user?.uuid,
      email: userTeam?.user?.email,
      numAppointmentsUsed: userTeam?.user?.numAppointmentsUsed,
      firstName: userTeam?.user?.firstName,
      lastName: userTeam?.user?.lastName,
      roleId: userTeam?.roleId,
      isAdmin: userTeam?.isAdmin,
      isDisabled: userTeam?.user?.isDisabled,
      accountType: userTeam?.user?.account?.accountType,
      isSelfSubscribed: userTeam?.isSelfSubscribed,
    })),
    teamInvites: team?.teamInvites?.map((invite) => ({
      uuid: invite?.uuid,
      timeSent: invite?.timeSent,
      timeResponded: invite?.timeResponded,
      inviteeEmail: invite?.inviteeEmail,
      status: invite?.status,
      inviteeRoleId: invite?.inviteeRoleId,
    })),
  };
  return mappedData;
};

export const mapRoleIdToRole = (roleId) => {
  return (
    {
      1: "DVM",
      2: "Practice Manager",
      3: "Locum",
      4: "Technician",
      5: "Other",
    }[roleId] || "Role Not Assigned"
  );
};
export const nonBillableRoles = [2, 4, 5];
